export enum BankIdState {
  ClientResponseNeeded = 0,
  Success = 1,
  Failed = 2,
}
